import { CARTOPOUSSE_BASE_URL } from '../utils/ApiUrls';

class ProcessService {
  // Create a new process with activities and reduction actions
  async createProcess(processData, accessToken) {
    try {
      console.log('📡 processService.createProcess - Sending data:', processData);
      
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/processes/create/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(processData),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Process creation failed',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get all published processes in the organization with filtering
  async getPublishedProcesses(accessToken, filters = {}, pagination_data) {
    try {
      console.log('📡 processService.getPublishedProcesses - Filters:', filters);
      
      // Build query parameters
      const queryParams = new URLSearchParams();
      
      if (filters.process_name) {
        queryParams.append('process_name', filters.process_name);
      }
      if (filters.status) {
        queryParams.append('status', filters.status);
      }
      if (filters.assigned_user) {
        queryParams.append('assigned_user', filters.assigned_user);
      }
      if (filters.probability) {
        queryParams.append('probability', filters.probability);
      }
      if (filters.ordering) {
        queryParams.append('ordering', filters.ordering);
      }

      if (pagination_data.page) {
        queryParams.append('page', pagination_data.page);
      }
      if (pagination_data.page_size) {
        queryParams.append('page_size', pagination_data.page_size);
      }

      const queryString = queryParams.toString();
      const url = `${CARTOPOUSSE_BASE_URL}/processes/published/${queryString ? `?${queryString}` : ''}`;
      
      console.log('📡 processService.getPublishedProcesses - URL:', url);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch published processes',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }


  // Get all processes in the organization with filtering
  async getAllOrganizationProcesses(accessToken, filters = {}, pagination_data) {
    try {
      // console.log('📡 processService.getPublishedProcesses - Filters:', filters);
      
      // Build query parameters
      const queryParams = new URLSearchParams();
      
      if (filters.process_name) {
        queryParams.append('process_name', filters.process_name);
      }
      if (filters.status) {
        queryParams.append('status', filters.status);
      }
      if (filters.assigned_user) {
        queryParams.append('assigned_user', filters.assigned_user);
      }
      if (filters.probability) {
        queryParams.append('probability', filters.probability);
      }
      if (filters.ordering) {
        queryParams.append('ordering', filters.ordering);
      }

      if(pagination_data.page){
        queryParams.append('page', pagination_data.page)
      }
      if(pagination_data.page_size){
        queryParams.append('page_size', pagination_data.page_size)
      }

      const queryString = queryParams.toString();
      const url = `${CARTOPOUSSE_BASE_URL}/processes/all/${queryString ? `?${queryString}` : ''}`;
      
      // console.log('📡 processService.getPublishedProcesses - URL:', url);


      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch published processes',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }


  // Get processes created by the current user with filtering
  async getMyProcesses(accessToken, filters = {}, pagination_data) {
    try {
      // console.log('📡 processService.getMyProcesses - Filters:', filters);
      
      // Build query parameters
      const queryParams = new URLSearchParams();
      
      if (filters.process_name) {
        queryParams.append('process_name', filters.process_name);
      }
      if (filters.status) {
        queryParams.append('status', filters.status);
      }
      if (filters.assigned_user) {
        queryParams.append('assigned_user', filters.assigned_user);
      }
      if (filters.probability) {
        queryParams.append('probability', filters.probability);
      }
      if (filters.ordering) {
        queryParams.append('ordering', filters.ordering);
      }
      if (pagination_data.page) {
        queryParams.append('page', pagination_data.page);
      }
      if (pagination_data.page_size) {
        queryParams.append('page_size', pagination_data.page_size);
      }

      const queryString = queryParams.toString();
      const url = `${CARTOPOUSSE_BASE_URL}/processes/my-processes/${queryString ? `?${queryString}` : ''}`;
      
      // console.log('📡 processService.getMyProcesses - URL:', url);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch user processes',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get detailed information about a specific process
  async getProcessDetails(processId, accessToken) {
    try {
      // console.log('📡 processService.getProcessDetails - Process ID:', processId);
      
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/processes/${processId}/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch process details',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Edit/Update an existing process
  async editProcess(processId, processData, accessToken) {
    try {
      // console.log('📡 processService.editProcess - Process ID:', processId);
      // console.log('📡 processService.editProcess - Sending data:', processData);
      
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/processes/${processId}/edit/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(processData),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Process update failed',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Alias for editProcess (for consistency)
  async updateProcess(processId, processData, accessToken) {
    return this.editProcess(processId, processData, accessToken);
  }

  // Delete a process
  async deleteProcess(processId, accessToken) {
    try {
      // console.log('📡 processService.deleteProcess - Process ID:', processId);
      
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/processes/${processId}/delete/`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Process deletion failed',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Change process status (draft -> published -> archived)
  async changeProcessStatus(processId, newStatus, accessToken) {
    try {
      // console.log('📡 processService.changeProcessStatus - Process ID:', processId);
      // console.log('📡 processService.changeProcessStatus - New Status:', newStatus);
      
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/processes/${processId}/status/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ status: newStatus }),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Status change failed',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }



  // Update the probability of an activityrisk
  async updateActivityRisk(riskId, updateData, accessToken) {
    try {
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/processes/activity-risks/${riskId}/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(updateData),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Status change failed',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }





  // Get all processes with complete hierarchy (public view)
  async getPublicProcesses(accessToken, filters = {}) {
    try {
      // console.log('📡 processService.getPublicProcesses - Filters:', filters);
      
      // Build query parameters
      const queryParams = new URLSearchParams();
      
      if (filters.process_name) {
        queryParams.append('process_name', filters.process_name);
      }
      if (filters.status) {
        queryParams.append('status', filters.status);
      }
      if (filters.assigned_user) {
        queryParams.append('assigned_user', filters.assigned_user);
      }
      if (filters.created_date_from) {
        queryParams.append('created_date_from', filters.created_date_from);
      }
      if (filters.created_date_to) {
        queryParams.append('created_date_to', filters.created_date_to);
      }
      if (filters.process_date_from) {
        queryParams.append('process_date_from', filters.process_date_from);
      }
      if (filters.process_date_to) {
        queryParams.append('process_date_to', filters.process_date_to);
      }
      if (filters.control_date_from) {
        queryParams.append('control_date_from', filters.control_date_from);
      }
      if (filters.control_date_to) {
        queryParams.append('control_date_to', filters.control_date_to);
      }
      if (filters.ordering) {
        queryParams.append('ordering', filters.ordering);
      }

      const queryString = queryParams.toString();
      const url = `${CARTOPOUSSE_BASE_URL}/processes/public-processes/${queryString ? `?${queryString}` : ''}`;
      
      // console.log('📡 processService.getPublicProcesses - URL:', url);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || data.error || 'Failed to fetch public processes',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get single process with complete hierarchy (public view)
  async getPublicProcessDetails(processId, accessToken) {
    try {
      // console.log('📡 processService.getPublicProcessDetails - Process ID:', processId);
      
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/processes/public-process/${processId}/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch public process details',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }
}

// Export a single instance
const processService = new ProcessService();
export default processService;
